var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 1240,
    viewBox: "0 0 76 1240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 23.0021C43.0011 20.2407 40.7635 18.0011 38.0021 18C35.2407 17.9989 33.0011 20.2365 33 22.9979L38 23L43 23.0021ZM37.4946 1238.04L66.3829 1188.05L8.64787 1188.03L37.4946 1238.04ZM38 23L33 22.9979L32.5133 1193.04L37.5133 1193.04L42.5133 1193.04L43 23.0021L38 23Z",
    fill: "#93A760"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1903,
    cy: 25.1903,
    r: 25.1903,
    transform: "matrix(-0.00120823 0.999999 0.999999 0.00120823 13.0609 0)",
    fill: "#93A760"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1903,
    cy: 25.1903,
    r: 25.1903,
    transform: "matrix(-0.00120823 0.999999 0.999999 0.00120823 13.0609 368)",
    fill: "#93A760"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1903,
    cy: 25.1903,
    r: 25.1903,
    transform: "matrix(-0.00120823 0.999999 0.999999 0.00120823 13.0609 742)",
    fill: "#93A760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.8c4c6d80a2a43bef0e926b915b2b1998.svg";
export { ForwardRef as ReactComponent };